export default __webpack_public_path__ + "static/media/ceramol-iage-night-treatment.57cb18d9.png";